import { render } from "./ProductDetail.vue?vue&type=template&id=2bcb8063&scoped=true&ts=true"
import script from "./ProductDetail.vue?vue&type=script&lang=ts"
export * from "./ProductDetail.vue?vue&type=script&lang=ts"

import "./ProductDetail.vue?vue&type=style&index=0&id=2bcb8063&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bcb8063"]])

export default __exports__